
document.addEventListener('DOMContentLoaded', (event) => {
          function getParamsToPersist() {
              const params = new URLSearchParams(window.location.search);
              let paramsString = '';
              const paramsToKeep = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

              paramsToKeep.forEach(key => {
                  if (params.has(key)) {
                      paramsString += `&${key}=${encodeURIComponent(params.get(key))}`;
                  }
              });

              if (paramsString) {
                  sessionStorage.setItem('persistentParams', paramsString);
              }
              
              return sessionStorage.getItem('persistentParams') || '';
          }

          const persistentParams = getParamsToPersist();

          if (persistentParams) {
              document.querySelectorAll('a[href^="/"], a[href^="https://somethingsbrewing.in"]').forEach(link => {        
                
                  const separator = link.href.includes('?') ? '&' : '?';            
                  if (
                      !link.href.includes('#') &&
                      !link.href.includes(persistentParams)
                  ) {
                      // Append parameters using the correct separator
                      link.href += separator + persistentParams.substring(1); 
                  }
              });
          }
});
